export default [
  {
    title: 'مدیریت پیام ها',
    icon: 'bx bx-message-dots',
    children: [
      {
        title: 'سگمنت سفارشی',
        route: { name: 'listSegment' },
        resource: 'SegmentManager',
        action: 'show',
      },

      {
        title: 'سگمنت پایه',
        route: { name: 'segmentbase' },
        resource: 'SegmentManager',
        action: 'show',
      },

      // {
      //   title: 'گزارش سگمنت',
      //   route: { name: 'reportSegment' },
      //   resource: 'TicketDepartmentManager',
      //   action: 'show',
      // },
      {
        title: 'پیام',
        route: { name: 'notificationList' },
        resource: 'NotificationManager',
        action: 'show',
      },
    ],
  },
]
